import { render, staticRenderFns } from "./InformacionGeneralPlanificacionAnual.vue?vue&type=template&id=c3587650&scoped=true"
import script from "./InformacionGeneralPlanificacionAnual.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralPlanificacionAnual.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralPlanificacionAnual.vue?vue&type=style&index=0&id=c3587650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3587650",
  null
  
)

export default component.exports